import {Api} from '@lsgo/lsgo-fe'

const version = '1.0.0';

export const api = new Api({location: window.location, application: `lsgo_teacher_application_${version}`});

export default api.axiosInstance;